import { AfterViewInit, ChangeDetectorRef, Component, HostListener, inject, PLATFORM_ID } from '@angular/core';
import { Device } from '../../app.component';
import { CommonModule, isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-home',
    imports: [CommonModule], // Standalone component imports
    templateUrl: './home.component.html',
    styleUrl: './home.component.less'
})
export class HomeComponent implements AfterViewInit {

  private platformId = inject(PLATFORM_ID);
  private cdr = inject(ChangeDetectorRef);
  
  device: Device = Device.Desktop;
  Device = Device;

  constructor() { }

  ngAfterViewInit() {
    this.onResize();
  }

  @HostListener('window:resize')
  onResize() {
    if (isPlatformBrowser(this.platformId)) {
      const screenWidth = window.innerWidth;
      const newDevice = screenWidth > 815 ? Device.Desktop : Device.Mobile;
      
      if (this.device !== newDevice) {
        this.device = newDevice;
        this.cdr.detectChanges();
      }
    }
  }

  scrollToSection(sectionId: string): void {
    if (isPlatformBrowser(this.platformId)) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

}